import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { Route, Switch } from 'react-router-dom'

import Conversation from './Conversation'
import Conversations from './Conversations'
import {canPostMessageToMobile, Message, postMessageToMobile} from "../Helpers/clientCommunication";

class Messages extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      device: props.device,

      conversations: undefined,

      systemMessage: {}
    }
  }

  callingAjax = false

  addConversation = (aid, participantIds, chat) => {
    this.apiConversationStart(aid, participantIds, chat)
  }

  getConversations = () => {
    let conversations = undefined

    if (this.state.conversations === undefined) {
      this.apiConversationsGet(this.props.aid)
    } else {
      conversations = this.state.conversations
    }

    return conversations
  }

  getConversation = conversationId => {
    let conversation = undefined

    if (this.state.conversations === undefined) {
      this.apiConversationsGet(this.props.aid)
    } else {
      conversation = this.state.conversations.filter(
        item => item.conversationId === conversationId
      )

      if (conversation.length > 0) {
        // We need to index into the returned array
        // This also fixes the weird situation where there might be more than one conversations with the same id
        conversation = conversation[0]
      } else conversation = null
    }

    return conversation
  }

  // Get a conversation between the logged in user and a particular account
  getConversationUser = fid => {
    let conversation = undefined

    if (this.state.conversations === undefined) {
      this.apiConversationsGet(this.props.aid)
    } else {
      conversation = this.state.conversations.filter(conversation => {
        let found = false

        // Links from the "My Friends" page should only have two participants
        if (conversation.participants.length < 3) {
          let userFound = false
          let requestedFound = false

          for (let i = 0; i < conversation.participants.length; i++) {
            // One of the participants needs to be the logged-in user
            if (conversation.participants[i].accountId === this.props.aid) {
              userFound = true
            }
            // One of the participants needs to be the requested user
            if (conversation.participants[i].accountId === fid) {
              requestedFound = true
            }
          }

          // If we have the two qualifying participants, we've found the right conversation
          if (userFound && requestedFound) {
            found = true
          }
        }

        return found
      })

      if (conversation.length > 0) {
        // We need to index into the returned array
        // This also fixes the weird situation where there might be more than one conversations with the same id
        conversation = conversation[0]
      } else conversation = null
    }

    return conversation
  }

  getChats = (convId, timestamp, polling = false) => {
    this.apiChatsGet(convId, timestamp, polling)
  }

  addChat = (aid, convId, message) => {
    this.apiChatAdd(aid, convId, message)
  }

  updateChatSeen = (aid, convId, chatId) => {
    // Fetch the list of conversations
    let conversations = this.getConversations()

    // Find this conversation
    for (let i = 0; i < conversations.length; i++) {
      if (conversations[i].conversationId === convId) {
        if (conversations[i].chats !== undefined) {
          // Now find the right chat message
          for (let j = 0; j < conversations[i].chats.length; j++) {
            if (conversations[i].chats[j].chatId === chatId) {
              if (conversations[i].chats[j].seenBy !== undefined) {
                // Finally we can update the "seenBy" array
                conversations[i].chats[j].seenBy.push(aid)
              } else conversations[i].chats[j].seenBy = [aid] // Or create it...
            }
          }
        }

        // Replace the conversations array with this new one because we've updated the "seen" status for one chat
        this.setState((state, props) => ({
          conversations: conversations
        }))

        break
      }
    }
  }

  apiLoadData = () => {
    this.apiConversationsGet(this.props.aid)
  }

  apiConversationStart = (aid, participantIds, message) => {
    let resultConversation = {}
    let participantList = {}

    let data = {
      accountId: aid,
      participants: participantIds,
      message: message
    }

    axios
      .post(config.apiServer + '/api/v3/chat/new-conversation', data, {
        // .post(
        //   'http://markus.cookn-cloud.appspot.com' +
        //     '/api/v3/chat/new-conversation',
        //   data,
        //  {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          const json = response.data

          if (json.key === 'OK') {
            // Fetch the list of conversations
            let conversations = this.getConversations()

            // Create a list of the friends involved in the new conversation
            participantList = this.props.friends.filter(
              friend => participantIds.indexOf(friend.accountId) !== -1
            )
            let user = {
              accountId: aid,
              id: aid,
              identifier: this.props.userIdentifier,
              name: this.props.userNameDisplay,
              userName: this.props.userNameDisplay
            }
            // Add the user to the list of participants
            participantList.push(user)

            // Create the JSON for the new conversation
            resultConversation = {
              conversationId: json.result.conversationId,
              participants: participantList
            }

            // Create the JSON for the first chat
            const newChat = {
              chatId: json.result.chatId,
              conversationId: json.result.conversationId,
              accountId: aid,
              dateCreated: new Date().getTime(), // For now, the current time will do
              seen: true,
              message: message
            }

            resultConversation.chats = newChat // Add the first chat to the conversation
            resultConversation.moreChats = false // There aren't more chats to grab because this is the first one

            // Add the conversation to the list of conversations
            conversations.push(resultConversation)

            // Now we need to sort the array of conversations in reverse chronological order according to the most recent chat message
            conversations.sort(function(a, b) {
              return (
                parseFloat(b['chats'][b['chats'].length - 1]['dateCreated']) -
                parseFloat(a['chats'][a['chats'].length - 1]['dateCreated'])
              )
            })

            this.setState((state, props) => ({
              conversations: conversations
            }))
          } else {
            console.log(json)
          }
        },
        error => {
          console.log(error)
        }
      )
  }

  apiConversationsGet = aid => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(config.apiServer + '/api/v3/chat/all-conversations?aid=' + aid, {})
        // .get(
        //   'http://markus.cookn-cloud.appspot.com' +
        //     '/api/v3/chat/all-conversations?aid=' +
        //     aid,
        //   {}
        // )
        .then(
          response => {
            this.callingAjax = false

            const json = response.data

            if (json.key === 'OK') {
              const resultsJson = json.result
              const resultsCount = resultsJson.length

              let resultsConversations = []

              if (resultsCount > 0) {
                // Fetch the conversations and put each bit of JSON into an array
                for (let i = 0; i < resultsCount; i++) {
                  let nextConversation = resultsJson[i]

                  // Before we push this conversation onto the array, let's  trigger a fetch for the most recent batch of chats so we can show the most recent ones by default.
                  this.apiChatsGet(resultsJson[i].conversationId)

                  nextConversation.moreChats = true // We don't know for sure if there are more chats or not, so we'll tell everyone to try fetching some at least once

                  resultsConversations.push(nextConversation)
                }
              }

              this.setState((state, props) => ({
                conversations: resultsConversations
              }))
            } else {
              console.log(json)
            }
          },
          error => {
            this.callingAjax = false

            console.log(error)
          }
        )
    }
  }

  apiChatAdd = (aid, convId, message) => {
    let resultChat = {}

    let data = {
      accountId: aid,
      conversationId: convId,
      message: message
    }

    axios
      .post(config.apiServer + '/api/v3/chat/new-chat', data, {
        // .post(
        //   'http://markus.cookn-cloud.appspot.com' + '/api/v3/chat/new-chat',
        //   data,
        //   {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          const json = response.data

          if (json.key === 'OK') {
            // Get the JSON for the new chat message
            const newChat = json.result

            // Fetch the list of conversations
            let conversations = this.getConversations()

            let resultsChats = []

            // Find this conversation
            for (let i = 0; i < conversations.length; i++) {
              if (conversations[i].conversationId === convId) {
                if (conversations[i].chats !== undefined) {
                  // Add the new chat message
                  resultsChats = conversations[i].chats
                  resultsChats.push(newChat)
                } else {
                  // Unexpected need to create the chats array, but we can handle this...
                  resultsChats.push(newChat)
                }

                // Sort the array by date
                resultsChats.sort(function(a, b) {
                  return (
                    parseFloat(a['dateCreated']) - parseFloat(b['dateCreated'])
                  )
                })

                // Overwrite the old chat array
                conversations[i].chats = resultsChats

                // Replace the conversations array with this new one because we've updated the chat history for one of the conversations
                this.setState((state, props) => ({
                  conversations: conversations
                }))

                break
              }
            }
          } else {
            console.log(json)
          }
        },
        error => {
          console.log(error)
        }
      )
  }

  apiChatsGet = (convId, timestamp, polling = false) => {
    let resultsChats = []

    let timestampUrlString = ''

    if (timestamp !== null && timestamp !== undefined) {
      if (polling) {
        timestampUrlString = '&ndt='
      } else {
        timestampUrlString = '&dt='
      }
      timestampUrlString = timestampUrlString + timestamp
    }

    axios
      .get(
        config.apiServer +
          '/api/v3/chat/chats?convid=' +
          convId +
          timestampUrlString,
        {}
      )
      // .get(
      //   'http://markus.cookn-cloud.appspot.com' +
      //     '/api/v3/chat/chats?convid=' +
      //     convId +
      //     timestampUrlString,
      //   {}
      // )
      .then(
        response => {
          const json = response.data

          if (json.key === 'OK') {
            let conversations = this.getConversations()

            if (json.result !== undefined) {
              const resultsJson = json.result
              const resultsCount = resultsJson.length

              if (resultsCount > 0) {
                // If there are existing chats, find them
                if (conversations !== undefined) {
                  for (let i = 0; i < conversations.length; i++) {
                    if (conversations[i].conversationId === convId) {
                      if (conversations[i].chats !== undefined) {
                        resultsChats = conversations[i].chats

                        // Fetch each additional chat's JSON
                        for (let i = 0; i < resultsCount; i++) {
                          // We have to make sure that each chat doesn't yet exist in the array
                          let chatExists = false
                          let chatCount = resultsChats.length

                          for (let j = 0; j < chatCount; j++) {
                            if (
                              resultsChats[j].chatId === resultsJson[i].chatId
                            ) {
                              chatExists = true
                            }
                          }

                          if (chatExists === false) {
                            // We need to check if we're polling, because if we are, we need to mark this new chat as "seen"
                            if (polling) {
                              let data = JSON.stringify({
                                accountId: this.props.aid,
                                conversationId: convId,
                                chatId: resultsJson[i].chatId
                              })

                              axios
                                .post(
                                  config.apiServer + '/api/v3/chat/seen',
                                  data,
                                  {
                                    headers: {
                                      'Content-Type': 'application/json'
                                    }
                                  }
                                )
                                .then(
                                  response => {
                                    const json = response.data

                                    // if (json.key === 'OK') {
                                    //   // We currently don't do anything if the return isn't what we want
                                    // } else {
                                    //   // We currently don't do anything if the return isn't what we want
                                    // }
                                    if (i === resultsJson.length - 1) {
                                      // This was the latest unseen chat, tell the mobile apps the conversation has been read
                                      const device = this.props.device
                                      const version = this.props.version
                                      if (canPostMessageToMobile(device, version)) {
                                        const message = new Message(Message.ACTION_DID_READ_CHAT_CONVERSATION, {})
                                        postMessageToMobile(device, version, message)
                                      } else {
                                        console.log("Conversation.markSeen: Messaging system not implemented, can't send message to mobile")
                                      }
                                    }
                                  },
                                  error => {
                                    console.log(error)
                                  }
                                )

                              // Update the chat's "seenBy" array
                              if (resultsJson[i].seenBy !== undefined) {
                                resultsJson[i].seenBy.push(this.props.aid) // Update the "seenBy" array
                              } else resultsJson[i].seenBy = [this.props.aid] // Or create it...
                            }
                            resultsChats.push(resultsJson[i])
                          }
                        }
                      } else {
                        for (let i = 0; i < resultsCount; i++) {
                          resultsChats.push(resultsJson[i])
                        }
                      }

                      // Sort the array by date
                      resultsChats.sort(function(a, b) {
                        return (
                          parseFloat(a['dateCreated']) -
                          parseFloat(b['dateCreated'])
                        )
                      })
                      conversations[i].chats = resultsChats

                      // Replace the conversations array with this new one because we've updated the chat history for one of the conversations
                      this.setState((state, props) => ({
                        conversations: conversations
                      }))

                      break
                    }
                  }
                }
              } else {
                // We found nothing, there aren't more results
                if (conversations !== undefined && polling === false) {
                  for (let i = 0; i < conversations.length; i++) {
                    if (conversations[i].conversationId === convId) {
                      conversations[i].moreChats = false

                      // Replace the conversations array with this new one because we've updated the chat history for one of the conversations
                      this.setState((state, props) => ({
                        conversations: conversations
                      }))

                      break
                    }
                  }
                }
              }
            } else {
              // We found nothing, there aren't more results
              if (conversations !== undefined && polling === false) {
                for (let i = 0; i < conversations.length; i++) {
                  if (conversations[i].conversationId === convId) {
                    conversations[i].moreChats = false

                    // Replace the conversations array with this new one because we've updated the chat history for one of the conversations
                    this.setState((state, props) => ({
                      conversations: conversations
                    }))

                    break
                  }
                }
              }
            }
          } else {
            // The response told us that things went awry somewhere
            // We may need more robust error handling here later
            console.log(json)
          }
        },
        error => {
          // Something went wrong with the AJAX request
          // We may need more robust error handling here later
          console.log(error)
        }
      )
  }

  componentDidMount() {
    this.apiLoadData()
  }

  /*<FirebaseContext.Provider>
        <FirebaseContext.Consumer value={new Firebase()}>
          {firebase => {
            return (*/

  /*)
          }}
        </FirebaseContext.Consumer>
      </FirebaseContext.Provider>*/

  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}/conversations/:conversationId`}
            render={({ match }) => (
              <Conversation
                device={this.props.device}
                version={this.props.version}
                aid={this.props.aid}
                conversation={this.getConversation(match.params.conversationId)}
                getChats={this.getChats}
                addChat={this.addChat}
                updateChatSeen={this.updateChatSeen}
              />
            )}
          />
          <Route
            path={`${this.props.match.url}/:accountId`}
            render={({ match }) => (
              <Conversation
                aid={this.props.aid}
                conversation={this.getConversationUser(match.params.accountId)}
                addConversation={this.addConversation}
                getChats={this.getChats}
                addChat={this.addChat}
                updateChatSeen={this.updateChatSeen}
                friends={this.props.friends}
                friendId={match.params.accountId}
              />
            )}
          />
          <Route
            render={({ match }) => (
              <Conversations
                aid={this.props.aid}
                conversations={this.getConversations()}
              />
            )}
          />
        </Switch>
      </div>
    )
  }
}

export default Messages



// WEBPACK FOOTER //
// ./src/Components/Messages.js